import { StringOptions } from "../../../../../components/Select";
import { SortDir, SortKey, SortState } from "./types";

// Card list (mobile) sort is a single select, so each sortable dimension is
// flattened into an explicit direction. Mirrors the desktop table sort keys.
export const SORT_OPTIONS: StringOptions[] = [
  { label: "↓ Debt", value: "debt:desc" },
  { label: "↑ Debt", value: "debt:asc" },
  { label: "↓ Paid", value: "paid:desc" },
  { label: "↑ Paid", value: "paid:asc" },
  { label: "↓ Progress", value: "progress:desc" },
  { label: "↑ Progress", value: "progress:asc" },
  { label: "↓ Rate", value: "rate:desc" },
  { label: "↑ Rate", value: "rate:asc" },
  { label: "↓ Started", value: "started:desc" },
  { label: "↑ Started", value: "started:asc" },
  { label: "↓ Ends", value: "ends:desc" },
  { label: "↑ Ends", value: "ends:asc" },
];

export const sortStateToValue = ({ key, dir }: SortState): string =>
  `${key}:${dir}`;

export const valueToSortState = (value: string): SortState => {
  const [key, dir] = value.split(":");
  return { key: key as SortKey, dir: dir as SortDir };
};
